import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Panel} from "primereact/panel";
import {InputText} from "primereact/inputtext";
import { FilterMatchMode } from 'primereact/api';
import axios from "axios";

const PurchaseorderInventorydocumentCopyListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();

  const inventoryDocumentId =
    props.inventoryDocumentId ||
    (window.App.urlVars && window.App.urlVars().inventoryDocumentId);

  const [attachedRelations, setAttachedRelations] = useState([]);
  const [loadingAttached, setLoadingAttached] = useState(false);

  const [candidateReceipts, setCandidateReceipts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [inventoryDocumentPartnerId, setInventoryDocumentPartnerId] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [receiptNumberQuery, setReceiptNumberQuery] = useState('');
  const receiptSearchTimerRef = useRef(null);
  const [filters, setFilters] = useState({
    'receipt_number': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'partner.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'net_amount': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'gross_amount': { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [attachedFilters, setAttachedFilters] = useState({
    'parent.receipt_number': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'parent.partner_name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'parent.net_amount': { value: null, matchMode: FilterMatchMode.EQUALS },
    'parent.gross_amount': { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        {localStorage.getItem('roles')?.toString().includes('role_') && (
          <Button
            icon="pi pi-eye"
            className="p-button p-mr-2"
            tooltip={t('receiptView')}
            tooltipOptions={{ position: 'left' }}
            onClick={() => {
              if (rowData.parent?.id) {
                window.App.setState?.({
                  sidebarReceiptFromInventory: true,
                  receiptFromInventoryInitialValues: {
                    id: rowData.parent.id,
                  },
                  props: {
                    external: true, 
                  },
                });
              }
            }}
          />
        )}
        {localStorage.getItem('roles')?.toString().includes('role_') && (
          <Button
            icon="pi pi-trash"
            className="p-button-danger"
            tooltip={t('delete')}
            tooltipOptions={{ position: 'left' }}
            onClick={() => {
              if (window.confirm('A törlés megerősítésére van szükség!')) {
                setLoadingAttached(true);
                apiCall('delete', '/api/v2/receipt-relation/' + rowData.id)
                  .then(() => {
                    window.App.toastShow('success', 'Sikeres törlés!');
                    loadAttachedRelations();
                    window.App.setState?.({
                      rerenderPurchaseorderInventorydocumentCopyList: Math.random()
                    });
                  })
                  .catch(error => {
                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                  })
                  .finally(() => {
                    setLoadingAttached(false);
                  });
              }
            }}
          />
        )}
      </>
    );
  };

  const candidateActionBodyTemplate = (rowData) => {
    return (
      <>
        {localStorage.getItem('roles')?.toString().includes('role_') && (
          <Button
            icon="pi pi-eye"
            className="p-button p-mr-2"
            tooltip={t('receiptView')}
            tooltipOptions={{ position: 'left' }}
            onClick={() => {
              if (rowData?.id) {
                window.App.setState?.({
                  sidebarReceiptFromInventory: true,
                  receiptFromInventoryInitialValues: {
                    id: rowData.id,
                  },
                  props: {
                    external: true,
                  },
                });
              }
            }}
          />
        )}
      </>
    );
  };

  const loadAttachedRelations = () => {
    if (!inventoryDocumentId) return;
    setLoadingAttached(true);
    apiCall(
      'get',
      `/api/v2/receipt-relation?search[inventory_document][operator]==&search[inventory_document][value][]=${inventoryDocumentId}`
    )
      .then(response => {
        const data = response.data.data;
        setAttachedRelations(data.items || data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoadingAttached(false);
      });
  };

  const loadInventoryDocumentAndReceipts = async () => {
  if (!inventoryDocumentId || Number.isNaN(inventoryDocumentId)) {
    setCandidateReceipts([]);
    setTotalRecords(0);
    return;
  }

  setLoading(true);
  try {
    const invRes = await apiCall('get', `/api/v2/inventory-document/${inventoryDocumentId}`);
    const partnerId = invRes?.data?.data?.partner?.id;
    // console.log('INVENTORY DOCUMENT PARTNER', partnerId, invRes?.data?.data);
    setInventoryDocumentPartnerId(partnerId);

    if (!partnerId) {
      setCandidateReceipts([]);
      setTotalRecords(0);
      return;
    }

    const url = `/api/v2/receipt` + `?search[partner][operator]==` + `&search[partner][value][]=${encodeURIComponent(partnerId)}` +
      `&search[receipt_type][operator]==` + `&search[receipt_type][value][]=SUPPLIER_INVOICE` + `&item_per_page=100`;

    const recRes = await apiCall('get', url);
    const recData = recRes.data.data;
    const items = recData.items || recData || [];
    setCandidateReceipts(items);
    setTotalRecords(items.length);
  } catch (error) {
      window.App.toastShow(
        'error',
        t('error'),
        error?.response?.data?.message || error.toString(),
        '',
        error.response
      );
    } finally {
      setLoading(false);
    }
  };

  const loadReceiptsByReceiptNumber = async (receiptNumber) => {
    const url = buildReceiptSearchUrlGlobal(receiptNumber);
    if (!url) return;
    setLoading(true);
    try {
      const recRes = await apiCall('get', url);
      const recData = recRes.data.data;
      const items = recData.items || recData || [];
      setCandidateReceipts(items);
      setTotalRecords(items.length);
      setSelectedReceipt(null);
    } catch (error) {
      window.App.toastShow(
        'error',
        t('error'),
        error?.response?.data?.message || error.toString(),
        '',
        error.response
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReceiptNumberFilterChange = (value) => {
    setReceiptNumberQuery(value);
    if (receiptSearchTimerRef.current) clearTimeout(receiptSearchTimerRef.current);
    receiptSearchTimerRef.current = setTimeout(() => {
      if (!value || value.trim() === '') {
        loadInventoryDocumentAndReceipts();
      } else {
        loadReceiptsByReceiptNumber(value);
      }
    }, 450);
  };

  const buildReceiptSearchUrlGlobal = (receiptNumber) => {
    const q = String(receiptNumber || '').trim();
    if (!q) return null;
    const likeValue = `*${q}*`;
    return (
      `/api/v2/receipt` + `?search[receipt_number][operator]=like` + `&search[receipt_number][value]=${encodeURIComponent(likeValue)}` + `&item_per_page=100`
    );
  };

  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];
      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={(e) => setRows(e.target.value)}
          appendTo={document.body}
        />
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  
  useEffect(() => {
    return () => {
      if (receiptSearchTimerRef.current) {
        clearTimeout(receiptSearchTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!inventoryDocumentId) return;
    loadAttachedRelations();
    loadInventoryDocumentAndReceipts();
  }, [inventoryDocumentId, window.App.state?.rerenderPurchaseorderInventorydocumentCopyList]);

  return (
    <>
      <Panel className="p-mb-0">
        <h3 className="p-m-0 p-mb-3 text-primary">{props.t('linkedInvoices')}</h3>
        <DataTable
          size={localStorage.getItem('scale')}
          value={attachedRelations}
          loading={loadingAttached}
          emptyMessage={t('noAttachedReceipt')}
          paginator
          rows={rows}
          paginatorTemplate={pager}
          autoLayout={true}
          filterDisplay="row"
          responsiveLayout="scroll"
          stripedRows
          dataKey="id"
          filters={attachedFilters}
          onFilter={(e) => setAttachedFilters(e.filters)}
        >
          <Column field="parent.receipt_number" header={t('columnSerialNumber')} sortable filter body={(rowData) => rowData.parent?.receipt_number}/>
          <Column field="parent.partner_name" header={t('columnPartner')} sortable filter body={(rowData) => rowData.parent?.partner_name}/>
          <Column field="parent.net_amount" header={t('columnNet')} sortable filter dataType='numeric'  body={(rowData) => window.App.currencyFormatter(rowData.parent?.currency || 'HUF', rowData.parent?.net_amount)}/>
          <Column field="parent.gross_amount" header={t('columnGross')} sortable filter dataType='numeric' body={(rowData) => window.App.currencyFormatter(rowData.parent?.currency ||'HUF', rowData.parent?.gross_amount)}/>
          <Column body={actionBodyTemplate} className="p-py-0 p-text-right p-text-nowrap"/>
        </DataTable>
      </Panel>

      <div
        className="p-my-3"
        style={{
          height: '12px',
          background: '#f4f4f7',
          marginLeft: '-1.25rem',
          marginRight: '-1.25rem'
        }}
      />

      <Panel>
        <div className="p-d-flex p-ai-start p-mb-3" style={{ width: '100%' }}>
          <h3 className="p-m-0 text-primary" style={{ flex: 1 }}>
            Számla csatolás
          </h3>
          <Button
            label="Számla hozzárendelés"
            className="p-button-success"
            disabled={!selectedReceipt || !selectedReceipt?.id || !inventoryDocumentId || loading}
            onClick={() => {
              if(entity === 'purchase-order') {
                history.push(
                  '/procurement/purchase-order/read/' +
                    id +
                    '?copy=inventorydocument-receipt&inventoryDocumentId=' +
                    inventoryDocumentId +
                    '&copyMode=dnd' + 
                    '&receiptId=' + selectedReceipt.id
                );
              }
            }}
          />
        </div>
        <DataTable
          size={localStorage.getItem('scale')}
          value={candidateReceipts}
          paginator
          rows={rows}
          paginatorTemplate={pager}
          emptyMessage={t('noResults')}
          autoLayout={true}
          filterDisplay="row"
          responsiveLayout="scroll"
          stripedRows
          ref={dt}
          dataKey="id"
          selectionMode="single"
          selection={selectedReceipt}
          onSelectionChange={(e) => setSelectedReceipt(e.value)}
          filters={filters}
          onFilter={(e) => setFilters(e.filters)}
        >
          <Column selectionMode="single" style={{ width: '3rem' }} />
          <Column field="receipt_number" header={t('columnSerialNumber')} sortable filter
          filterElement={() => (
            <InputText
              value={receiptNumberQuery}
              onChange={(e) => handleReceiptNumberFilterChange(e.target.value)}
              placeholder={t('serialNumberSearchPlaceholder')}className="p-column-filter"
            />
          )}
          />
          <Column field="partner.name" header={t('columnPartner')}  sortable filter body={(rowData) => rowData.partner?.name} />
          <Column field="net_amount" header={t('columnNet')} sortable filter
          body={(rowData) => window.App.currencyFormatter(rowData.currency, rowData.net_amount)} filterElement={(options) => (
            <InputText
              value={options.value || ''}
              onChange={(e) => options.filterApplyCallback(e.target.value)}
              className="p-column-filter"
            />
          )} />
          <Column field="gross_amount" header={t('columnGross')} sortable filter
          body={(rowData) => window.App.currencyFormatter(rowData.currency, rowData.gross_amount)} filterElement={(options) => (
            <InputText
              value={options.value || ''}
              onChange={(e) => options.filterApplyCallback(e.target.value)}
              className="p-column-filter"
            />
          )}/>
          <Column body={candidateActionBodyTemplate} className="p-py-0 p-text-right p-text-nowrap"/>
        </DataTable>
      </Panel>
    </>
  );
};

export default withTranslation('common')(PurchaseorderInventorydocumentCopyListComponent);
